import {
  Box,
  Checkbox,
  CircularProgress,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useIsFetching } from "@tanstack/react-query";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CourseDetailModal } from "./CourseDetailModal";
import { CoursesTable } from "./CoursesTable";
import { Button } from "../../components";
import { ButtonGroupsExternalTrainings } from "../../components/ButtonGroupsExternalTraining";
// import { ContentBox, Description } from "../../components/CardProfile/CardProfile.styles";
import { CommonWidgetContainer } from "../../components/Commons/CommonWidgetContainer.styles";
import { ExternalSidebar } from "../../components/ExternalTraining/ExternalSidebar";
import { useExternalTrainingData } from "../../components/ExternalTraining/ExternalTrainingData";
import { ExternalTrainingPage } from "../../components/ExternalTraining/ExternalTrainingPage";
import { DataResponse, Options } from "../../components/InputCst/MultiSelectCst/types";
import { ExternalTrainingModal } from "../../components/Modal/ExternalTrainingModal";
// import SidebarFilters from "../../components/Modal/SidebarFilter";
import { ModalBasic } from "../../components/ModalBasic";
import { useCapabilitiesOptionsQuery, useCourseTypesOptionsQuery, useCampaignsOptionsQuery, useDeleteExternalCertificate, useDeleteExternalTraining, useKnowledgeAreasOptionsQuery, useKnowledgeDomainsOptionsQuery, usePostExternalTrainingConsuntivazione } from "../../queries/skillbook";
import { Domain, Errors, Field, FormValues, MultiSelectOptionsProps, SkillBookExternal } from "../../routes/Profile/AddSkillBook/AddSkillBook.types";
import { useAuthStore } from "../../stores";
import { form_skillBook_add } from "../../utils/form_configurations";
import { downloadBlobFile } from "../../utils/general";
import { onSubmitExternal } from "../../utils/skillBook";
import { Icon } from "../Icon/Icon.component";
import OutputMessageModal from "../Message/OutputMessageModal.component";



export function CompletedButton({
  completed,
  setCompleted,
  readOnly
}: {
  completed: boolean;
  setCompleted: React.Dispatch<React.SetStateAction<boolean>>;
  readOnly?: boolean;
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  const toggleCompleted = () => {
    if (readOnly) return;
    setCompleted(prev => !prev);
  };

  return (
    <Box
      onClick={ readOnly ? undefined : toggleCompleted }
      aria-pressed={ completed }
      sx={ {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: theme.customColors.backgroundPrimaryCta,
        borderRadius: "8px",
        padding: "12px 16px",
        cursor: "pointer",
        mt: 2
      } }
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        color={ theme.customColors.textWidgetAlternative }
      >
        { t("comleted_button") }
      </Typography>

      <Checkbox
        checked={ completed }
        disableRipple
        sx={ {
          p: 0,
          "& svg": {
            fontSize: 24
          },
          "& .MuiSvgIcon-root path": {
            fill: theme.customColors.textWidgetAlternative
          }
        } }
        disabled={ readOnly }
      />
    </Box>
  );
}



export function SignupSummaryExternalTraining() {
  const { t } = useTranslation();
  const theme = useTheme();
  const [formValues, setFormValues] = React.useState<FormValues>({});
  const [errors, setErrors] = React.useState<Errors>({});
  const [courseTypes, setCourseTypes] = useState<Options[]>([]);
  const [campaignOptions, setCampaignOptions] = useState<Options[]>([]);


  const [knowledgeAreas, setKnowledgeAreas] = useState<MultiSelectOptionsProps[]>([]);
  const [knowledgeDomains, setKnowledgeDomains] = useState<MultiSelectOptionsProps[]>([]);
  const [capabilities, setCapabilities] = useState<MultiSelectOptionsProps[]>([]);
  const [selectedArea, setSelectedArea] = useState<{ isUpdating: boolean; value?: string | number }>({
    isUpdating: false,
    value: ""
  });
  const [filter, setFilter] = useState<string>("all");

  const [completed, setCompleted] = useState<boolean>(false);

  const handleFilterChange = (newFilter: string) => {
    setFilter(newFilter);
    setCurrentPage(1);
    setSelectedStatusFilter([]);
    setSearchTerm("");
    setSelectedCourse(null);
  };
  //const [selectedStatus, setSelectedStatus] = useState<string>("all");
  const [selectedStatusFilter, setSelectedStatusFilter] = useState<string[]>([]); // ARRAY

  const [searchTerm, setSearchTerm] = useState("");


  const handleDateChange = (name: string) => (date: Date | null) => {
    if (date instanceof Date && !isNaN(date.getTime())) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: formattedDate
      }));
    } else {
      // Fallback: resetta o ignora
      console.warn(`❌ Data non valida per campo "${name}"`, date);
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: ""
      }));
    }
  };

  const [ courses, setCourses] = useState<CourseItem[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<CourseItem | null>(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const handleSelectCourse = (course: CourseItem) => {
    setSelectedCourse(course);
    setIsDetailModalOpen(true);
  };
  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
  };
  const [editCourse, setEditCourse] = useState<CourseItem | null>(null);
  const handleEditCourse = (course: CourseItem) => {
    setIsDetailModalOpen(false);
    setEditCourse(course);
    setOpen(true);
  };

  // const filteredCourses = courses.filter(course => {
  //   const matchType =
  //     filter === "iscrizioni"
  //       ? course.type?.toLowerCase() === "iscrizione"
  //       : filter === "consuntivazione"
  //         ? course.type?.toLowerCase() === "consuntivazione"
  //         : true;

  //   const matchStatus =
  //     selectedStatus === "all" ? true : course.status === selectedStatus;

  //   const matchesSearch =
  //     course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     course.provider?.toLowerCase().includes(searchTerm.toLowerCase());

  //   return matchType && matchStatus && matchesSearch;
  // });

  const filteredCourses = courses.filter(course => {
    const matchType =
      filter === "interna"
        ? course.source === "internal"
        : filter === "iscrizione"
          ? course.type?.toLowerCase() === "iscrizione"
          : filter === "consultivazione"
            ? course.type?.toLowerCase() === "consuntivazione"
            : true;

    const matchStatus =
      selectedStatusFilter.length === 0          // array vuoto ⇒ mostra tutto
        ? true
        : selectedStatusFilter.includes(course.status);

    const matchesSearch =
      course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      course.provider?.toLowerCase().includes(searchTerm.toLowerCase());

    return matchType && matchStatus && matchesSearch;
  });


  //TODO sparisce un'iscrizione che ha lo stesso ID della consuntivazione?
  const mergeCoursesById = (prev: CourseItem[], next: CourseItem[]): CourseItem[] => {
    const combined = [...prev, ...next];
    return Array.from(new Map(combined.map(item => [item.id, item])).values());
  };

  const userId = useAuthStore(state => state.userData?.id_user) ?? "";
  const corporateId = useAuthStore(state => state.userData?.organization_id) ?? "";
  const name = useAuthStore(state => state.userData?.name) ?? "";
  const surname = useAuthStore(state => state.userData?.surname) ?? "";

  const handleChangeMultiSelect = (
    event: { label: string; value: string | number }[],
    accessorKey: string
  ) => {
    if (!["knowledgeArea", "knowledgeDomain", "capability"].includes(accessorKey)) return;
    let newValues: Options[] = [];

    const formValueArray = (formValues[accessorKey] as Options[]) || [];
    const itemsToAdd = event.filter(ev => !formValueArray.some(fv => fv.value === ev.value));
    const itemsToRemove = formValueArray.filter(fv => !event.some(ev => ev.value === fv.value));

    if (accessorKey === "knowledgeArea" && itemsToAdd[0])
      setSelectedArea({ isUpdating: true, value: itemsToAdd[0].value });

    if (accessorKey === "knowledgeArea" && itemsToRemove[0]) {
      const updatedDomains = knowledgeDomains.filter(domain =>
        itemsToRemove.every(item => domain.parent !== item.value)
      );
      setKnowledgeDomains(updatedDomains);
      setFormValues(prev => ({ ...prev, knowledgeDomain: [] }));
    }

    newValues = [
      ...formValueArray.filter(fv => !itemsToRemove.includes(fv)),
      ...itemsToAdd
    ];

    setFormValues(prev => ({ ...prev, [accessorKey]: newValues }));
  };


  useCapabilitiesOptionsQuery({
    onError: (error) => {
      console.error("Error fetching data Capabilities:", error);
    },
    onSuccess: (data: { output: [] }) => {
      const newCapabilities = data.output.map((item: DataResponse) => ({
        label: item.name,
        value: item.id
      }));

      setCapabilities(newCapabilities as MultiSelectOptionsProps[]);
    }
  });

  useCourseTypesOptionsQuery({
    onError: (error) => {
      console.error("Error fetching data Course Types:", error);
    },
    onSuccess: (data: unknown) => {
      const newCourseTypes = (data as DataResponse[]).map((item: DataResponse) => ({
        label: item.name || item.label,
        value: item.id ? String(item.id) : item.value ? String(item.value) : ""
      }));

      return setCourseTypes(newCourseTypes as Options[]);
    }
  });

  useCampaignsOptionsQuery({
    enabled: Boolean(corporateId),
    onError: (error) => {
      console.error("Error fetching campaigns:", error);
    },
    onSuccess: (data: unknown) => {

      console.log("campaigns fetched:",data);

      const campaigns = (data as { output: DataResponse[] }).output;

      const newCampaignOptions: Options[] = campaigns.map(item => ({
        label: item.name ?? "",
        value: String(item.id)
      }));

      setCampaignOptions(newCampaignOptions);
      console.log("campaigns fetched and cleaned:",campaignOptions);
    }
  });

  useKnowledgeAreasOptionsQuery({
    onError: (error) => {
      console.error("Error fetching data Areas:", error);
    },
    onSuccess: (data: { output: DataResponse[] }) => {
      const newKnowledgeArea = data.output.map((item: DataResponse) => ({
        label: item.name,
        value: item.id
      }));

      setKnowledgeAreas(newKnowledgeArea as MultiSelectOptionsProps[]);
    }
  });

  useKnowledgeDomainsOptionsQuery({
    enabled: selectedArea.isUpdating && !!selectedArea.value,
    onError: (error) => {
      console.error("Error fetching data Domains:", error);
    },
    onSuccess: (data: { output: DataResponse[] }) => {
      const areaId = selectedArea.isUpdating && selectedArea.value ? selectedArea.value.toString() : "";
      if (!areaId) return;
      const newKnowledgeDomain = data.output.map((item: DataResponse) => ({
        label: item.name,
        parent: selectedArea.value,
        value: item.id
      }));

      // newKnowledgeDomain.push(...knowledgeDomains as []);

      setKnowledgeDomains(newKnowledgeDomain as MultiSelectOptionsProps[]);
      setSelectedArea({ isUpdating: false });
      console.log("Data domain fetched successfully:", data);
    },
    knowledgeAreaId: selectedArea.isUpdating && selectedArea.value ? selectedArea.value.toString() : ""
  });

  // const [coursesAreLoading, setCoursesAreLoading] = useState<boolean>(true);

  const anyFetching = useIsFetching({
    predicate: q =>
      Array.isArray(q.queryKey) &&
      (q.queryKey[0] === "externalCert" || q.queryKey[0] === "externalTrain")
  }) > 0;
  const coursesAreLoading = courses.length === 0 && anyFetching;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
  };
  const formData = form_skillBook_add.fields;

  const validateForm = () => {
    let newErrors: Errors = {};
    const today = new Date();
    const startDate =new Date(formValues.startDate as string);
    const endDate = new Date(formValues.endDate as string);
    const validationStartDate = new Date(formValues.validationStartDate as string);
    const validationEndDate = new Date(formValues.validationEndDate as string);
    formData.forEach((field: Field) => {
      if (field.required && !formValues[field.name] && field.name != "duration") {
        newErrors[field.name] = t(`${field.name}_required`);
      }
    });
    if (startDate > today) {
      newErrors.startDate = t("date_in_future_error");
    }
    if (endDate > today) {
      newErrors.endDate = t("date_in_future_error");
    }
    if (endDate < startDate) {
      newErrors.endDate = t("endDate_before_startDate_error");
    }
    if (validationEndDate < today) {
      newErrors.validationEndDate = t("certificate_expired");
    }
    if (validationEndDate < validationStartDate) {
      newErrors.validationEndDate = t("validationEndDate_before_validationStartDate_error");
    }
    if (validationStartDate < endDate) {
      newErrors.validationStartDate = t("validation_start_date_before_end_course");
    }

    if (formValues.duration !== "" && formValues.duration !== null && formValues.duration !== undefined) {
      const durationValue = Number(formValues.duration);

      if (isNaN(durationValue)) {
        newErrors.duration = t("duration_type_value_error");
      } else if (durationValue < 0) {
        newErrors.duration = t("duration_negative_value_error");
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUploadCertificate = (course: CourseItem, file: File) => {
    const defaultOptionTrainingMode = courseTypes.find(
      (opt) => opt.label === course.trainingMode
    ) || { label: "-", value: "" };

    const data: Partial<SkillBookExternal> = {
      area_domain: course.area
        ? course.area.flatMap((areaItem) =>
          (areaItem.domain || []).map((domainItem: Domain) => ({
            knowledge_area: { label: areaItem.label, value: areaItem.id },
            knowledge_domain: { label: domainItem.label, value: domainItem.id }
          }))
        )
        : [],
      attachments: [],
      campaign: course.campaign ?? "",
      campaignId: course.campaignId ?? "",
      capability: course.capability?.map((c) => ({ label: c.label, value: c.id })) ?? [],
      cost: course.cost,
      customFields: course.customFields ?? [],
      data_fine_validita: course.certificateEndValidityDate ?? "",
      data_inizio_validita: course.certificateStartValidityDate ?? "",
      description: course.description,
      duration: course.duration ?? 0,
      durationParticipation: String(course.durationParticipation ?? 0),
      endDate: course.endDate ?? "",
      file: file as unknown as string,
      link_certificato: course.certificate_url ?? "",
      motivation: course.motivation ?? "",
      plan: course.plan ?? "",
      provider: course.provider,
      source: course.source,
      startDate: course.startDate,
      teacher: course.instructor ?? "",
      title: course.title,
      trainingType: defaultOptionTrainingMode as unknown as SkillBookExternal["trainingType"]
    };

    onSubmitExternal(
      data as unknown as SkillBookExternal,
      mutate as unknown as (data: FormData) => void,
      course.id
    );
  };

  const handleDownloadCertificate = async (url: string) => {
    try {
      const response = await fetch(url, { method: "GET" });
      if (!response.ok) throw new Error(`HTTP error ${response.status}`);
      const blob = await response.blob();
      downloadBlobFile({ fileName: "certificato.pdf", blobFile: blob });
    } catch (err) {
      console.error("Errore durante il download del PDF:", err);
      window.open(url, "_blank");
    }
  };

  const handleConfirm = async () => {
    if (!selectedCourse?.id) {
      console.error("Nessuna iscrizione selezionata. L'id è richiesto.");
      // setOpen(true);
      return;
    }
    if (!validateForm()) {
      setErrors((prevErrors) => ({ ...prevErrors }));
      return;
    }

    // setIsOutputModalOpen(true);

    try {
      onSubmitExternal(
        formValues as unknown as SkillBookExternal,
        mutate as unknown as (data: FormData) => void,
        selectedCourse?.id
      );

      if (completed && selectedCourse.type === "Iscrizione") {
        setSuppressDeleteModal(true);
        //deleteExternalTraining(selectedCourse.id);
        handleRefresh();
      }
    } catch (error) {
      console.error("Errore durante la conferma:", error);
    }
  };

  const onCancel = () => {
    setFormValues({});
  };

  const [refreshKey, setRefreshKey] = useState(0);
  const handleRefresh = () => {
    setCourses([]);
    setRefreshKey(prev => prev + 1);
  };
  const [suppressDeleteModal, setSuppressDeleteModal] = useState(false);


  const { mutate: deleteExternalTraining } = useDeleteExternalTraining({

    onSuccess: () => {

      setDeleteSuccess(true);
      if (!suppressDeleteModal) {
        setIsDeleteModalOpen(true);
      }
      setSelectedCourse(null);

    },
    onError: (error) => {
      setDeleteSuccess(false);
      if (!suppressDeleteModal) {
        setIsDeleteModalOpen(true);
      }
      console.error(error);
    }
  });

  const { mutate: deleteExternalCertificate } = useDeleteExternalCertificate({
    onSuccess: () => {
      setDeleteSuccess(true);
      if (!suppressDeleteModal) {
        setIsDeleteModalOpen(true);
      }
      setIsDeleteModalOpen(true);
      setSelectedCourse(null);
    },
    onError: (error) => {
      setDeleteSuccess(false);
      if (!suppressDeleteModal) {
        setIsDeleteModalOpen(true);
      }
      console.error(error);
    }
  });


  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState<boolean | null>(null);

  const onDelete = () => {
    if (!selectedCourse || selectedCourse.status !== "PENDING") return;
    if (selectedCourse.type === "Iscrizione") {
      deleteExternalTraining(selectedCourse.id);
    } else if (selectedCourse.type === "Consuntivazione") {
      deleteExternalCertificate(selectedCourse.id);
    }
  };


  const [currentPage, setCurrentPage] = useState(1);
  const [sortKey, setSortKey] = useState<"status" | "type" | "startDate" | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

  const handleSortChange = (key: "status" | "type" | "startDate" | null) => {
    if (sortKey === key) {
      setSortDirection(prev => prev === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortDirection("asc");
    }
    setCurrentPage(1);
  };

  const itemsPerPage = 10;
  const sortedCourses = [...filteredCourses].sort((a, b) => {
    if (!sortKey) {
      const dateA = a.endDate ? new Date(a.endDate).getTime() : 0;
      const dateB = b.endDate ? new Date(b.endDate).getTime() : 0;
      return dateB - dateA;
    }
    const dir = sortDirection === "asc" ? 1 : -1;
    if (sortKey === "status") {
      return dir * (a.status ?? "").localeCompare(b.status ?? "");
    }
    if (sortKey === "type") {
      const valA = a.provider || a.type || "";
      const valB = b.provider || b.type || "";
      return dir * valA.localeCompare(valB);
    }
    if (sortKey === "startDate") {
      const dateA = a.startDate ? new Date(a.startDate).getTime() : 0;
      const dateB = b.startDate ? new Date(b.startDate).getTime() : 0;
      return dir * (dateA - dateB);
    }
    return 0;
  });

  const paginatedCourses = sortedCourses.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  useExternalTrainingData(userId,corporateId,name,surname,setCourses,mergeCoursesById,refreshKey);

  // useEffect(() => {
  //   setCoursesAreLoading(false);
  // }, [courses]);

  const { mutate } = usePostExternalTrainingConsuntivazione({
    onSuccess: (data: unknown) => {
      console.log("Successo:", data);
      // setOpen(true);
      setSubmitSucceeded(true);
      setIsOutputModalOpen(true);
      handleRefresh();

      if (selectedCourse != null && selectedCourse.type === "Iscrizione") {
        setSuppressDeleteModal(true);

        // deleteExternalTraining(selectedCourse.id);
      }
    },
    onError: (error) => {
      console.error("Errore:", error);
      // setOpen(true);
      setSubmitSucceeded(false);
      setIsOutputModalOpen(true);
    }
  });

  const handleCloseConfirmModal = () => {
    console.log("handle close confirm modal");
    setOpen(false);
    handleClose();
    setRefreshKey(prev => prev + 1);
  };

  const handleCloseModalAndRefresh = () => {
    console.log("handle close modal and refresh print, refreshKey: ",refreshKey);
    setOpen(false);
    setRefreshKey(prev => prev + 1);
    //window.location.reload();
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setEditCourse(null);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);


  //const isMedium = useMediaQuery(theme.breakpoints.down("md"));

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const _isLarge = useMediaQuery(theme.breakpoints.down("lg"));
  const [isOutputModalOpen, setIsOutputModalOpen] = React.useState(false);
  const handleCloseWithRefresh = () => {
    setIsOutputModalOpen(false);
    setRefreshKey(prev => prev + 1);
  };
  const [submitSucceeded, setSubmitSucceeded] = useState<boolean>();


  if (coursesAreLoading) {
    return (
      <Box
        sx={ { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 400 } }
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }




  return (
    <>
      { /* === HEADER: CV Formativo === */ }
      <Box
        sx={ {
          alignItems: isMobile ? "flex-start" : "center",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 2,
          justifyContent: "space-between",
          mb: 3,
          width: "100%"
        } }
      >
        <Box>
          <Typography
            color={ theme.customColors.textPrimary }
            fontWeight={ 700 }
            sx={ { mb: 0.5 } }
            variant="h5"
            fontSize={ "1.25rem" }
          >
            { /* TODO tradurre?  */ }
            CV Formativo 
          </Typography>
          <Typography
            color={ theme.customColors.textPrimary }
            fontSize="1rem"
            sx={ { opacity: 0.7 } }
          >
            { /* TODO tradurre?  */ }
            Tutte le attivit&agrave; formative svolte e in corso
          </Typography>
        </Box>

        <Box
          sx={ {
            display: "flex",
            flexWrap: "wrap",
            gap: 1.5
          } }
        >
          <Button
            onClick={ handleOpen }
            sx={ {
              borderColor: theme.customColors.border,
              borderRadius: "8px",
              color: theme.customColors.textPrimary,
              fontSize: "0.85rem",
              px: 2,
              py: 1,
              textTransform: "none"
            } }
            variant="outlined"
          >
            { t("upload_external_training") }
            <Icon
              icon="Icons_upload"
              size={ 18 }
              sx={ { marginLeft: 1 } }
            />
          </Button>
          { /* TODO:verrà visualizzato in seguito 
          <Button
            onClick={ () => {
              // TODO: collegare download CSV
            } }
            sx={ {
              borderColor: theme.customColors.border,
              borderRadius: "8px",
              color: theme.customColors.textPrimary,
              fontSize: "0.85rem",
              px: 2,
              py: 1,
              textTransform: "none"
            } }
            variant="outlined"
          >
            { t("download_formative_cv") }
            <Icon
              icon="Icons_download"
              size={ 18 }
              sx={ { marginLeft: 1 } }
            />
          </Button>
          */ }
        </Box>
      </Box>

      <ModalBasic
        open={ open }
        title={ "" }
        content={
          <ExternalTrainingModal
            closeModal={ handleCloseModalAndRefresh }
            initialData={ editCourse ?? undefined }
          />
        }
        handleClose={ handleCloseConfirmModal }
      />

      { /* === FILTRI + TABELLA === */ }
      { courses.length > 0 && (
        <CommonWidgetContainer
          sx={ {
            alignItems: "flex-start",
            borderRadius: "16px",
            color: theme.customColors.exploreCardText,
            display: "flex",
            flexDirection: "column",
            gap: 0,
            maxWidth: "100%",
            mt: 2,
            width: "100%"
          } }
        >
          { /* Filtri inline */ }
          <Box
            sx={ {
              p: 2,
              width: "100%"
            } }
          >
            <ExternalSidebar
              filter={ filter }
              onFilterChange={ handleFilterChange }
              selectedStatus={ selectedStatusFilter }
              setSelectedStatus={ setSelectedStatusFilter }
              searchTerm={ searchTerm }
              setSearchTerm={ setSearchTerm }
            />
          </Box>

          { /* Tabella dei risultati */ }
          <Box sx={ { p: 2, width: "100%" } }>
            <CoursesTable
              courses={ filteredCourses }
              selectedCourse={ selectedCourse }
              onSelect={ handleSelectCourse }
              filter={ filter }
              paginatedCourses={ paginatedCourses }
              currentPage={ currentPage }
              itemsPerPage={ itemsPerPage }
              setCurrentPage={ setCurrentPage }
              sortKey={ sortKey }
              sortDirection={ sortDirection }
              onSortChange={ handleSortChange }
              onUploadCertificate={ handleUploadCertificate }
              onMarkAsCompleted={ (course) => {
                setSelectedCourse(course);
                setCompleted(true);
              } }
            />
          </Box>

          { /* Dettaglio corso selezionato */ }
          { selectedCourse && (
            <Box
              sx={ {
                borderTop: `1px solid ${theme.customColors.border}`,
                p: 2,
                width: "100%"
              } }
            >
              <ExternalTrainingPage
                formValues={ formValues }
                setFormValues={ setFormValues }
                filter={ filter }
                formData={ formData }
                handleDateChange={ handleDateChange }
                courseTypes={ courseTypes }
                campaignOptions={ campaignOptions }
                knowledgeAreas={ knowledgeAreas }
                knowledgeDomains={ knowledgeDomains }
                capabilities={ capabilities }
                handleInputChange={ handleInputChange }
                setSelectedArea={ setSelectedArea }
                handleChangeMultiSelect={ handleChangeMultiSelect }
                selectedCourse={ selectedCourse }
                errors={ errors }
                completedFlag={ completed }
                setCompletedFlag={ setCompleted }
                readOnly={
                  selectedCourse?.status === "PENDING" ||
                  !selectedCourse ||
                  ( selectedCourse?.status === "APPROVED" &&
                    selectedCourse.type === "Consuntivazione") ||
                  selectedCourse?.status === "REJECTED"
                }
              />

              <ButtonGroupsExternalTrainings
                onClickDelete={ onDelete }
                onClickCancel={ onCancel }
                onClickConfirm={ handleConfirm }
                isPending={
                  selectedCourse?.status === "PENDING"
                }
                isCourseSelected={
                  selectedCourse?.status === "APPROVED" &&
                  selectedCourse?.type === "Consuntivazione"
                }
              />
            </Box>
          ) }

        </CommonWidgetContainer>
      ) }

      { /* Modals */ }
      <ModalBasic
        open={ isOutputModalOpen }
        title={ "" }
        content={
          <OutputMessageModal
            success={ submitSucceeded ?? false }
            closeModal={ handleCloseWithRefresh }
          />
        }
        handleClose={ handleCloseWithRefresh }
        size={ { width: { sm: "40vw", xs: "100vw" } } }
      />

      <ModalBasic
        open={ isDeleteModalOpen }
        title={
          deleteSuccess
            ? t("delete_success")
            : t("delete_failed")
        }
        content={
          <Box textAlign="center">
            <Typography variant="body1" sx={ { mb: 3 } }>
              { deleteSuccess
                ? t("delete_course_success")
                : t("delete_course_failed") }
            </Typography>
            <Button
              onClick={ () => {
                setIsDeleteModalOpen(false);
                setDeleteSuccess(null);
                handleRefresh();
              } }
              variant="contained"
              sx={ {
                "&:hover": {
                  backgroundColor: "#d63256"
                },
                backgroundColor: "#F43E63",
                borderRadius: 2,
                color: theme.customColors.textPrimary,
                fontWeight: "bold",
                px: 4,
                textTransform: "uppercase"
              } }
            >
              { t("close") }
            </Button>
          </Box>
        }
        handleClose={ handleRefresh }
        size={ { width: { sm: "30vw", xs: "100vw" } } }
      />

      { /* Modale dettaglio corso */ }
      { selectedCourse && (
        <CourseDetailModal
          open={ isDetailModalOpen }
          course={ selectedCourse }
          onClose={ handleCloseDetailModal }
          onDownloadCertificate={ handleDownloadCertificate }
          onUploadCertificate={ handleUploadCertificate }
          onEdit={ handleEditCourse }
        />
      ) }
    </>
  );
}
